// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"c33067b228afb0c1","4726":"3735a69f5c866115"}[chunkId] + ".css";
};